export default __webpack_public_path__ + "static/media/XEMP-23.35886652.jpg";